import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {showSuccessMsg} from '../../util/messagesUtil';

export class UsuarioPlataforma extends React.Component {

    atualizarCheckBox() {
        document.getElementById(this.props.usuarioSelecionado.id).checked = true;
    }

    exibirStatus() {
        if (this.props.interessado.rolesName.length) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }

    resetarSenha(id) {
        this.props.resetarSenhaUsuarioPlataformaWeb(id).then(() => {
            showSuccessMsg('Senha resetada com sucesso!');
        });
    }

    render() {
        return (
            <div className="geral">
                <div className="resumo">
                    <div className="row">
                        <div className="col-sm-12 col-md">
                            <span className="titulo-mobile">Nome:&nbsp;</span>{this.props.interessado.nome}
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <div style={{ width: '210px', wordWrap: 'break-word' }}>
                                <span className="titulo-mobile">E-mail:&nbsp;</span>{this.props.interessado.email}
                            </div>
                        </div>
                        <div className="col-sm-12 col-md">
                            <span className="titulo-mobile">Telefone:&nbsp;</span>{this.props.interessado.telefone}
                        </div>
                        <div className="col-sm-12 col-md">
                            <span className="titulo-mobile">Origem:&nbsp;</span>{this.props.interessado.plataforma?this.props.interessado.plataforma: 'Não informado'}
                        </div>
                        <div className="col-sm-12 col-md">
                            <span className="titulo-mobile">Tipo:&nbsp;</span>{this.props.interessado.plataforma ? 'Desconto': 'Impressão'}
                        </div>
                        <div className="col-sm-12 col-md">
                            <span className="titulo-mobile">Cid. Origem:&nbsp;</span>{this.props.interessado.cidadeOrigem ? this.props.interessado.cidadeOrigem.nomeComUf : ''}
                        </div>
                        <div className="col-sm-12 col-md">
                            <span className="titulo-mobile">Cid. Destino:&nbsp;</span>{this.props.interessado.cidadeDestino ? this.props.interessado.cidadeDestino.nomeComUf : ''}
                        </div>
                        <div className="col-sm-12 col-md">
                            <span className="titulo-mobile">Data de entrada:&nbsp;</span>{this.props.interessado.dataHora}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        usuarioSelecionado: state.usuarioSelecionado
    }
}

export default connect(mapStateToProps, {
    changeFieldValue,
})(reduxForm({
    form: 'formularioAlterarUsuario'
})(UsuarioPlataforma))
